import { ReactNode } from "react";

import { Content } from "./content";

export const UpgradeEligibleUser = (props: {
    SiteNameInput?: ReactNode;
    NewSiteLink?: ReactNode;
    SiteToggleButton?: ReactNode;
    SubmitButton?: ReactNode;
}) => <Content {...props} />;
